import Today from "../img/today.png";
import MyHealth from "../img/myhealth.png";
import MyClinic from "../img/myclinic.png";
import Menu from "../img/menu.png";
import Library from "../img/library.png";
import { Carousel } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

function IntroPage(props) {
  let history = useHistory();
  const { t } = useTranslation();
  return (
    <div className="body_content mt-0">
      <div className="inner_body d-block">
        <Carousel
          className="banner_slider stick-dots"
          controls={true}
          slide={true}
        >
          <Carousel.Item>
            <div className="slide">
              <div className="row">
                <div className="col-12 gridcol ">
                  <div className="thumbnail">
                    <img src={Today} className="img-fluid img_fit" />
                  </div>
                  <div className="caption">
                    <h3 className="headtitle">
                      {t("introPage.INTRO.page1.today")}
                    </h3>
                    <p className="desc">
                      {t("introPage.INTRO.page1.organise")}
                    </p>
                  </div>
                  <div className="bottom_slider">
                    <span
                      className="txt_skip"
                      onClick={() => history.push("/home")}
                    >
                      {t("introPage.INTRO.page1.skip")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="slide">
              <div className="row">
                <div className="col-12 gridcol ">
                  <div className="thumbnail">
                    <img src={MyHealth} className="img-fluid img_fit" />
                  </div>
                  <div className="caption">
                    <h3 className="headtitle">
                      {t("introPage.INTRO.page2.health")}
                    </h3>
                    <p className="desc">
                      {t("introPage.INTRO.page2.clinical")}
                    </p>
                  </div>
                  <div className="bottom_slider">
                    <span
                      className="txt_skip"
                      onClick={() => history.push("/home")}
                    >
                      {t("introPage.INTRO.page1.skip")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="slide">
              <div className="row">
                <div className="col-12 gridcol ">
                  <div className="thumbnail">
                    <img src={MyClinic} className="img-fluid img_fit" />
                  </div>
                  <div className="caption">
                    <h3 className="headtitle">
                      {t("introPage.INTRO.page3.clinic1")}
                    </h3>
                    <p className="desc">{t("introPage.INTRO.page3.clinic2")}</p>
                  </div>
                  <div className="bottom_slider">
                    <span
                      className="txt_skip"
                      onClick={() => history.push("/home")}
                    >
                      {t("introPage.INTRO.page1.skip")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="slide">
              <div className="row">
                <div className="col-12 gridcol ">
                  <div className="thumbnail">
                    <img src={Menu} className="img-fluid img_fit" />
                  </div>
                  <div className="caption">
                    <h3 className="headtitle">
                      {t("introPage.INTRO.page4.menu")}
                    </h3>
                    <p className="desc">
                      {t("introPage.INTRO.page4.personal")}
                    </p>
                  </div>
                  <div className="bottom_slider">
                    <span
                      className="txt_skip"
                      onClick={() => history.push("/home")}
                    >
                      {t("introPage.INTRO.page1.skip")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="slide">
              <div className="row">
                <div className="col-12 gridcol ">
                  <div className="thumbnail">
                    <img src={Library} className="img-fluid img_fit" />
                  </div>
                  <div className="caption">
                    <h3 className="headtitle">
                      {t("introPage.INTRO.page5.library")}
                    </h3>
                    <p className="desc">{t("introPage.INTRO.page5.videos")}</p>
                  </div>
                  <div className="bottom_slider btn_block d-flex justify-content-center">
                    <button
                      className="btn btn_primary"
                      onClick={() => history.push("/home")}
                    >
                      {t("introPage.INTRO.page5.done")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Item>
        </Carousel>
      </div>
    </div>
  );
}

export default IntroPage;
